<template>
  <div>
    <b-modal id="org-tree-employee-search-modal" hide-footer
             :modal-class="`adp-modal`"
             :body-class="`adp-modal-body`" :header-class="`adp-big-modal-header`">

      <template #modal-title>
        <div class="d-flex">
          <span class="modal-title adp-h2 adp-h2__modal">{{ $t('idp.employee_list') }}</span>
        </div>
      </template>
      <template #modal-header-close>
        <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
      </template>
      <template>

        <div class="mass-assignments-modal-org-search">
          <template>
            <div class="d-flex">
              <div class="custom-control custom-checkbox menu-label mass-assignments-modal-search--checkbox"
                   :class="{'partial-checked': partialChecked}" @click="toggleCheckedSearch">
                <input type="checkbox" class="custom-control-input" v-model="allChecked" value="1" checked>
                <span class="custom-control-label" style="cursor: pointer">{{ '' }}</span>
              </div>
              <div class="d-flex flex-column mass-assignments-modal-search--search">
                <span class="adp-th">{{ $t('catalog.assign_search_group') }}</span>
                <input type="text" class="adp-input adp-input__catalog adp-input-search" v-model="search">
              </div>
            </div>
          </template>
        </div>
        <div class="mass-assignments-modal-block">
          <div class="adp-big-modal-row">
            <structure-tree v-if="checkedItems[company.id]"
                            v-for="(company, key) in companies"
                            :key="company.id"
                            :search="search"
                            :parent="company"
                            :label="company.name"
                            :open="false"
                            :preset-values="{}"
                            :parentChecked="checkedItems[company.id].checked"
                            :parentShowMobile="checkedItems[company.id].showMobile"
                            :parentLevel="0"
                            :checkedItems="checkedItems[company.id]"
                            @toggleMobile="toggleMobile"
                            @updateItemsSearch="updateItemsSearch"
                            @updateItemsChecked="updateItemsChecked">
            </structure-tree>
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn adp-btn" @click="applyFilter">{{ $t('voc.save') }}</button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>

import StructureTree from "../StructureTree";
import ActivityTypeSelect from "../ActivityTypeSelect";

export default {
  name: "OrgTreeEmployeeSearchModal",
  components: {
    StructureTree,
    ActivityTypeSelect
  },
  props: {
    groups: {
      type: Array,
      required: false,
    },
    group: {
      type: String,
      required: false,
    },
  },
  data: function () {
    return {
      assignedActivitiesText: '',
      userAssignments: {},
      search: '',
      errorText: '',
      noUsersError: false,
      companies: {},
      partialChecked: false,
      allChecked: false,
      checkedItems: {},
      selectedGroup: this.group,
    }
  },
  created() {

    axios.get('/' + window.IDP.role + '/structure').then(response => {
      if (response.data.departments && Object.keys(response.data.departments).length) {
        this.companies = Object.assign({}, response.data.departments);
      } else {
        this.noUsersError = true;
      }

      for (let [key, value] of Object.entries(this.companies)) {
        let checked = false;
        let changed = false;

        this.checkedItems[value.id] = {
          partialChecked: false, items: {}, id: value.id,
          checked: checked, changed: changed,
          inSearch: false, itemsSearch: false,
          showMobile: true, itemsOpenMobile: false,
          type: value.type, name: value.name,
        }
      }
    });
  },
  watch: {
    search: function () {
      this.noUsersError = false;
    },
  },
  methods: {
    applyFilter() {
      let checked = this.getCheckedItems(this.checkedItems);

      if(!checked.length) {
        return;
      }
      this.$emit('apply-filter', JSON.parse(JSON.stringify(checked)));
      this.$bvModal.hide('org-tree-employee-search-modal');
    },

    toggleCheckedSearch() {
      this.allChecked = !this.allChecked;

      _.each(this.checkedItems, (item) => {
        item.checked = this.allChecked;
      });
    },

    updateItemsSearch() {

    },

    toggleMobile(id, open) {
      this.partialChecked =
      _.each(this.checkedItems, (item) => {
        if(id !== item.id) {
          item.showMobile = open;
        }
      });
      this.checkedItems = Object.assign({}, this.checkedItems);
    },

    close() {
      this.$bvModal.hide('mass-assignments-modal');
      $('.adp-navbar').removeClass('adp-navbar-fixed');
    },

    updateItemsChecked() {
      const length = Object.keys(this.checkedItems).length;

      const checkedItems = Object.values(this.checkedItems).filter(function (item) {
        return item.checked;
      });

      const partialCheckedItems = Object.values(this.checkedItems).filter(function (item) {
        return item.partialChecked;
      });

      this.partialChecked = (checkedItems.length && checkedItems.length !== length) || partialCheckedItems.length;

      if (checkedItems.length && checkedItems.length === length) this.allChecked = true;
      if (!checkedItems.length && !partialCheckedItems.length) this.allChecked = false;
    },

    getCheckedItems(items) {
      let checked = []

      Object.keys(items).forEach(key => {
        if (items[key].checked && !items[key].partialChecked) {
          checked.push({'type': items[key].type, 'id': items[key].id})
        }

        if (items[key].items && Object.keys(items[key].items).length && items[key].partialChecked) {
          let itemChecked = this.getCheckedItems(items[key].items)
          checked = checked.concat(itemChecked)
        }
      });

      return checked;
    },
  },
}
</script>

<style>
.adp-filter-input--no-result {
  padding-left: 24px;
  margin-top: 20px;
  font-size: 16px;
}

.notifications-error {
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 25px;
}
</style>
